<template>
    <div class="sports_item_detail sports_register_detail">
        <div class="viewhover">
            <div class="label">赛事基础信息</div>
            <van-cell-group v-if="matchid">
                <van-cell title="赛事编码" :value="number" />
                <van-cell title="赛事名称" :value="itemDetail.match_name" />
                <van-cell title="比赛项目" :value="itemDetail.project" />
                <van-cell title="赛事板块" :value="itemDetail.match_plate" />
                <van-cell title="赛事级别" :value="itemDetail.match_level" />
                <van-cell title="比赛时间" :value="itemDetail.starttime" />
                <van-field v-model="address" label="调研地点" placeholder="请输入" />
                <van-cell title="评估人" :value="userInfo.nickname" />
            </van-cell-group>
            <van-cell-group v-else>
                <van-field v-model="form.title" label="赛事名称" placeholder="请输入" />
                <van-cell title-style="width:1.5rem;flex: none;" title="赛事板块" :value="form.match_plate" @click="showPicker = true" />
                <van-cell title-style="width:1.5rem;flex: none;" title="比赛项目" :value="form.project" @click="showPicker2 = true" />
                <!-- <van-field v-model="form.match_plate" label="赛事板块" placeholder="请输入" /> -->
                <!-- <van-field v-model="form.project" label="比赛项目" placeholder="请输入" /> -->
                
                <van-cell title-style="width:1.5rem;flex: none;" title="赛事级别" :value="form.match_level" />
                <van-cell title-style="width:1.5rem;flex: none;" title="比赛时间" :value="form.date" @click="show = true" />
                <van-field v-model="form.address" label="调研地点" placeholder="请输入" />
                <van-cell title-style="width:1.5rem;flex: none;" title="评估人" :value="userInfo.nickname" />
            </van-cell-group>
        </div>
        <div class="viewhover">
            <div class="label sign">
                <div>办赛单位责任人签字</div>
                <div class="btn" @click="clear">清除</div>
            </div>
            <div class="boder" v-touch:end="endHandler2">
                <vueSignature ref="signature2" :w="'100%'" :h="'2rem'" :sigOption="option"></vueSignature>
            </div>
        </div>
        <div style="height: 2rem;">&nbsp;</div> 
        <div class="footer">
            <Button
            type="default"
            round
            @click="goblack"
            class="mvbutton"
            style="width: 3rem;height:.8rem"
            >取消</Button>
            <Button
            round    
            plain
            type="info"
            @click="submit"
            style="width: 3rem;height:.8rem"
            >下一步</Button>
        </div>
        <van-calendar v-model="show" :min-date="minDate" type="range" @confirm="onConfirm" />
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm1"
            />
        </van-popup>
        <van-popup v-model="showPicker2" round position="bottom">
            <van-picker
                show-toolbar
                :columns="columns2"
                @cancel="showPicker2 = false"
                @confirm="onConfirm2"
            />
        </van-popup>
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index.vue'
    import {Empty, Panel, Cell, Button, CellGroup, Field,Popup,Calendar,Picker} from 'vant';
    import Params from '@/libs/params'
    import vueSignature from "vue-signature"
    import moment from 'moment';
    

    import "./index.less"

    export default {
        computed: {
            buttonColor() {
                return `#0598D6`;
            }
        },
        components: {
            Empty,
            Panel,
            VanCell:Cell,
            Button,
            VanCellGroup:CellGroup,
            Footbar,
            Form,
            VanField: Field,
            vueSignature,
            VanPopup:Popup,
            VanCalendar:Calendar,
            VanPicker:Picker
        },
        data() {
            return {
                detail: '',
                itemDetail: "",
                evid: '',
                matchid: '',
                title: '',
                registerform: [],
                option: {
                    panColor: "rgb(0,0,0)",
                    bacgroundColor: "rgb(245,245,245)"
                },                
                allnum: 0,
                score: 0,
                address: '',
                previous_checker: '',
                userInfo: {},
                principal: '',
                appraiser: '',
                form: {
                    title: '',
                    project: '请选择',
                    match_plate_id: '',
                    match_plate: '请选择',
                    start_time: '',
                    end_time: '',
                    match_level: '市级',
                    address: '',
                    date: '请选择'                  
                },
                show: false,
                showPicker: false,
                showPicker2: false,
                plist: [],
                columns: [],
                columns2: [],
                prlist: [],
                minDate: new Date(2023, 1, 1),
                number: ''
            }
        },
        methods: {
            onConfirm1(value) {
                console.log(value)
                let item = this.plist.find(ele=>ele.match_plate == value)
                this.form.match_plate_id = item.match_plate_id
                this.form.match_plate = value;
                this.showPicker = false;
                this.getPro()
            },
            onConfirm2(value) {
                console.log(value)
                let item = this.prlist.find(ele=>ele.name == value)
                this.form.project_id = item.id
                this.form.project = value;
                this.showPicker2 = false;
            },
            getPro() {
                this.$api.match.getProlist({plate_id:this.form.match_plate_id}).then(res=>{
                    this.prlist = res.data
                    let arr = []
                    res.data.forEach(item=>{
                        arr.push(item.name)
                    })
                    this.columns2 = arr
                })
            },
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            onConfirm(date) {
                const [start, end] = date;
                this.form.start_time = new Date(start).getTime()/1000
                this.form.end_time = new Date(end).getTime()/1000
                this.show = false;
                this.form.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            },
            clear() {
                if(this.principal) {
                    this.$refs.signature2.clear();
                    this.principal = ''
                }
                
            },
            goblack(){
                this.$router.go(-1)
            },
            // endHandler() {
            //     var png = this.$refs.signature.save()
            //     let file = {
            //         content: png,
            //         imgkey: 'file'
            //     }
            //     this.$api.system.upload(file).then(res=>{
            //         this.appraiser = res.data.imgurl
            //     })
            // },
            endHandler2() {               
                var png = this.$refs.signature2.save()
                let file = {
                    content: png,
                    imgkey: 'file'
                }
                this.$api.system.upload(file).then(res=>{
                    this.principal = res.data.imgurl
                })
            },
            submit: function () {
                if(this.principal=='') {
                    this.$toast.fail('办赛单位责任人还未签名')
                    return
                }
                if(this.address=='' && this.matchid) {
                    this.$toast.fail('请填写调研地点')
                    return
                }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                });
                let that = this
                // var score = 0
                // e.forEach(item=>{
                //     if(item.type==1) {
                //         score += item.value*1
                //     }  
                // })
                // this.score = score
        
                let query = {
                    // appraiser:this.appraiser,
                    step: 1,
                    principal:this.principal,
                    // score,
                    base_id: this.matchid,
                    // registerform: JSON.stringify(e),
                    // previous_checker: this.previous_checker,
                    address: this.address
                }
                if(!this.matchid) {
                    if(this.form.address=='') {
                        this.$toast.fail('请填写调研地点')
                        return
                    }
                    if(this.form.match_plate=='' || this.form.project=='') {
                        this.$toast.fail('请填写板块及项目')
                        return
                    }
                    if(this.form.start_time=='' || this.form.end_time=='') {
                        this.$toast.fail('请填写赛事时间')
                        return
                    }
                    query = Object.assign(query,this.form)
                }
                this.$api.match.editEnv(query).then((res) => {
                    this.$toast.clear();
                    if (res.success) {
                        this.$toast.success('成功');
                        this.$router.push({name:'joinMatch',params: {evid: res.data.id,matchid: this.matchid}})
                    }
                    
                })
                    
            },
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
                let params = {matchid: this.matchid}
                this.$api.match.getMatchdetail(params).then((res) => {
                    if (res.data.registerform) {
                        try {
                            res.data.registerform = JSON.parse(res.data.registerform);
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    res.data.starttime = moment(res.data.start_time*1000).format('YYYY-MM-DD')
                    this.address = res.data.matchInfo.length?res.data.matchInfo[0].address:''
                    this.number = res.data.matchInfo.length?res.data.matchInfo[0].number:''
                    this.itemDetail = res.data
                    let registerform = []
                    let arr = 0
                    if(res.data.match_plate_id== 3 || res.data.match_plate_id== 4) {
                        registerform = Params.attr
                    } else if (res.data.match_plate_id== 2) {
                        registerform = Params.brand
                    } else {
                        registerform = Params.league
                    }
                    registerform.forEach(item=>{
                        if(item.type==1) {
                            arr +=item.max*1
                        }
                    })
                    this.allnum = arr

                    this.registerform = registerform
                    this.$toast.clear();
                })
                

            },
            getinfo() {
                this.$api.user.getUserInfo().then(res=>{
                    this.userInfo = res.data
                })
                this.$api.match.getPlist().then(res=>{
                    let {
                        platelist
                    } = res.data;
                    let arr = []
                    platelist.forEach(item=>{
                        arr.push(item.match_plate)
                    })
                    this.columns = arr
                    this.plist = platelist
                })
            }
        },
        mounted() {
            this.matchid = this.$route.params.matchid
            if(this.matchid) {
                this.init();
            }
            
            this.getinfo()
        }

    }
</script>
